import { Box, Breadcrumbs, Typography } from "@mui/material"
import { ReactComponent as HomeIcon } from "../../../assets/imgs/icons/home.svg"
import { useLocation, useNavigate } from "react-router-dom"

export default function BreadCrumbs({ tenant, bookingData }) {
  const location = useLocation()
  const navigate = useNavigate()

  const isBookingSummary = location.pathname.includes("/booking")

  const tenantName = isBookingSummary ? bookingData?.tenant : tenant?.data?.name

  const tenantSlug =
    tenant?.data?.slug ||
    bookingData?.tenantSlug ||
    sessionStorage.getItem("tenant")

  return (
    <Box sx={{ display: "flex", alignItems: "center", my: 2 }}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator="›"
        sx={{
          "& .MuiBreadcrumbs-separator": { color: "text.secondary" },
          fontSize: 14,
        }}
      >
        {/* Home Icon */}
        <Box
          role="link"
          tabIndex={0}
          onClick={() => navigate("/home")}
          onKeyDown={(e) => e.key === "Enter" && navigate("/home")}
          sx={{
            display: "flex",
            alignItems: "center",
            color: "text.secondary",
            textDecoration: "none",
            cursor: "pointer",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          <HomeIcon style={{ fontSize: 20, marginRight: 4 }} />
        </Box>

        {/* Tenant Name */}
        <Box
          role={isBookingSummary ? "link" : undefined}
          tabIndex={isBookingSummary ? 0 : -1}
          onClick={() => {
            if (!isBookingSummary) return
            navigate(`/tenant?tenant=${encodeURIComponent(tenantSlug)}`)
          }}
          onKeyDown={(e) => {
            if (!isBookingSummary) return
            if (e.key === "Enter") {
              navigate(`/tenant?tenant=${encodeURIComponent(tenantSlug)}`)
            }
          }}
          sx={{
            color: isBookingSummary ? "text.secondary" : "text.link.admin",
            textDecoration: "none",
            fontWeight: isBookingSummary ? 400 : 700,
            fontSize: "16px",
            cursor: isBookingSummary ? "pointer" : "default",
            "&:hover": {
              textDecoration: isBookingSummary ? "underline" : "none",
            },
          }}
        >
          {tenantName}
        </Box>

        {isBookingSummary && (
          <Typography
            sx={{
              cursor: "default",
              fontWeight: 700,
              fontSize: "16px",
              color: "text.link.admin",
            }}
          >
            Booking Summary
          </Typography>
        )}
      </Breadcrumbs>
    </Box>
  )
}
